<template>
  <div>
    <van-cell-group>
      <van-cell title="姓名" :value="form.iccid" />
      <van-cell title="手机号" :value="form.status" />
      <van-cell title="上级代理" :value="form.carrier" />
      <van-cell title="等级" :value="form.activeDate" />
      <van-cell title="累计分润" :value="form.offTime" />
      <van-cell title="账户余额" :value="form.remainFlow" />
      <van-cell title="团队数量" :value="form.remainFlows" />
      <van-cell title="下级设备" class="ckxq" value="查看详情" @click="ViewDetails" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    form: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    ViewDetails () {
      this.$router.push({ name: 'Recharge', params: { iccid: this.$store.state.iccd } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/.van-cell__value {
    flex: 2;
  }
  .ckxq {
    /deep/.van-cell__value {
      color: rgb(42, 111, 238)!important;
    }
  }
  .weappIcon {
    font-size: 40px;
    line-height: inherit;
  }
  [class*=van-hairline]::after {
    border: none;
  }
</style>
